import { Injectable } from '@angular/core';
import { StoreInterface } from '../interfaces/store.interface';
import { OperationItemsStore } from './entities/operation-items/operation-items.store';
import { OperationItemsQuery } from './entities/operation-items/operation-items.query';

@Injectable({ providedIn: 'root' })
export class OperationItemsStoreService {
  private stores = new Map();

  constructor() {}

  getOrCreateStore(name: string): StoreInterface<OperationItemsStore, OperationItemsQuery> {
    if (!name) {
      return;
    }
    if (this.stores.has(name)) {
      return this.getState(name);
    } else {
      const store = new OperationItemsStore(name);
      const query = new OperationItemsQuery(store);

      const state = { store, query };
      this.stores.set(name, state);
      return state;
    }
  }

  private getState(name: string) {
    return this.stores.get(name);
  }
}
